import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './core/header/header';
import { FooterComponent } from './core/footer/footer';
import { SpinnerComponent } from './shared/spinner/spinner';
import { CookieBannerComponent } from "./shared/cookie-banner/cookie-banner";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HeaderComponent, FooterComponent, CookieBannerComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'Site AGBE';
  
  public isLoading = true;

  ngOnInit() {
    // Fin du chargement après 1.5s (ou synchro avec ton initialisation)
    setTimeout(() => {
      this.isLoading = false;
    }, 1500);
  }
}
